import { render, staticRenderFns } from "./LaudoListagem.vue?vue&type=template&id=20837452&scoped=true&lang=pug"
import script from "./LaudoListagem.vue?vue&type=script&lang=js"
export * from "./LaudoListagem.vue?vue&type=script&lang=js"
import style0 from "./LaudoListagem.vue?vue&type=style&index=0&id=20837452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20837452",
  null
  
)

export default component.exports